import { Component, inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ApiUser, ArticlesApi } from "@tytapp/api";
import { ApiArticle } from "@tytapp/api/model/Article";
import { PageComponent, PagedArray } from "@tytapp/common";
import { UserService } from "@tytapp/user";

@Component({
    templateUrl: './all-articles.component.html',
    styleUrls: ['./all-articles.component.scss']
})
export class AllArticlesComponent extends PageComponent {
    private articlesApi = inject(ArticlesApi);
    private userService = inject(UserService);

    page: number;
    articles: PagedArray<ApiArticle>;
    user: ApiUser;
    statuses: string[] = [];
    status: string = 'published';
    total: number;
    pageSize = 50;

    get isStaff() {
        if (!this.user)
            return false;

        return this.user.staff;
    }

    humanizeStatus(status) {

        let map: any = {
            published: 'Published',
            drafts: 'Drafts',
            scheduled: 'Scheduled'
        };

        if (!this.isStaff) {
            map = {
                published: 'All'
            };
        }

        return map[status] || status;
    }

    async fetchArticles() {
        this.articles = null;
        this.articles = await this.articlesApi.all((this.page - 1) * this.pageSize, this.pageSize, this.status).toPromise();
        this.total = this.articles.total;
    }

    init() {

        this.subscribe(this.userService.userChanged, user => {
            this.user = user;
            if (this.isStaff) {
                this.statuses = ['published', 'drafts', 'scheduled'];
            } else {
                this.statuses = ['published'];
            }
        });

        this.route.queryParamMap.subscribe(map => {
            this.status = map.get('status') || 'published';
            this.page = Number(map.get('page')) || 1;
            this.fetchArticles();
        });
    }

    goToPage(page: number) {
        this.page = page;

        this.router.navigate([], {
            queryParams: {
                status: this.status,
                page: this.page
            }
        });
    }

    switchStatus(status: string) {
        this.page = 1;
        this.router.navigate([], {
            queryParams: {
                status,
                page: this.page
            }
        });
    }
}